import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {SharedModule} from '../../../../shared/shared.module';
import {ChatPipesModule} from '../../shared/pipes/pipes.module';
import {EditModule} from '../../../../components/edit/edit.module';
import {MessageComponent} from './message.component';


@NgModule({
  imports: [
    CommonModule,
    PdfViewerModule,
    SharedModule,
    ChatPipesModule,
    EditModule
  ],
  declarations: [
    MessageComponent
  ],
  exports: [
    MessageComponent
  ],
  entryComponents: [
    MessageComponent
  ]
})

export class MessageModule {}
